import React from "react";
import { Alert, Space, Tag } from "antd";

const severityToType = {
  error: "error",
  warning: "warning",
  info: "info",
};

export default function AdminPriceTraceAnomalies({ anomalies }) {
  if (!Array.isArray(anomalies) || anomalies.length === 0) {
    return (
      <Alert type="success" showIcon message="אין חריגות שזוהו אוטומטית" className="apt-anomalies" />
    );
  }

  return (
    <Space direction="vertical" size={8} className="apt-anomalies" style={{ width: "100%" }}>
      {anomalies.map((a) => (
        <Alert
          key={`${a.code}-${(a.relatedStepKeys || []).join("-")}`}
          type={severityToType[a.severity] || "info"}
          showIcon
          message={
            <span>
              <Tag>{a.code}</Tag> {a.message}
            </span>
          }
          description={
            Array.isArray(a.relatedStepKeys) && a.relatedStepKeys.length > 0
              ? `שלבים קשורים: ${a.relatedStepKeys.join(", ")}`
              : null
          }
        />
      ))}
    </Space>
  );
}
